<payee-chip-dropdown
  [placeholder]="'PAYEE_CASE_MOKK_TABLE.FILTERS.PAYEE_CASE_REFERENCE_ID' | translate"
  [selected]="chipSelected"
  [displayWith]="displayWith"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="clearFilter()"
>
  <payee-form-field width="wide">
    <span payee-label>{{ "PAYEE_CASE_MOKK_TABLE.FILTERS.PAYEE_CASE_REFERENCE_ID" | translate }}</span>
    <input
      payee-input
      [formControl]="control"
      (paste)="closeAfterPaste()"
    />
  </payee-form-field>
</payee-chip-dropdown>
